import { delay, generateCryptoCode } from './helper.js';
import { OrderApiError, OrderDiscount, OrderDto } from './interfaces/index.js';

const apiBaseUrl = 'https://scan-lab-api.deno.dev';
const apiVersion = 'v0';
const authHeader = {
  Authorization: 'db4bd6eb-4829-4455-b20a-5adfbd58ca57',
};

const ordersEndpoint = `${apiBaseUrl}/${apiVersion}/orders`;
const ordersDiscountEndpoint = (code: string) =>
  `${apiBaseUrl}/${apiVersion}/orders/${encodeURIComponent(code)}/discount`;

const apiFetch = async <T>(
  url: string,
  options: RequestInit = {}
): Promise<T> => {
  const response = await fetch(url, {
    ...options,
    headers: {
      ...authHeader,
      Accept: 'application/json',
      ...options.headers,
    },
  });

  if (!response.ok) {
    const errorData = await response.json();
    const { code, details } = errorData;

    throw new OrderApiError(
      `Request failed: ${response.status} ${response.statusText}`,
      response.status,
      code,
      details
    );
  }

  return (await response.json()) as T;
};

export const fetchOrderDiscount = async (code: string) => {
  return apiFetch<OrderDiscount>(ordersDiscountEndpoint(code), {
    method: 'GET',
  });
};

export const fetchOrder = async (
  orderId: string,
  abortSignal?: AbortSignal
): Promise<OrderDto> => {
  await delay(1000);

  return apiFetch<OrderDto>(
    `${ordersEndpoint}/${encodeURIComponent(orderId)}`,
    {
      method: 'GET',
      signal: abortSignal,
    }
  );
};

export const createOrder = async () => {
  const code = generateCryptoCode();

  await apiFetch(ordersEndpoint, {
    method: 'POST',
    body: JSON.stringify({ code }),
  });

  return { code };
};
